import {
  QueryClient,
  defaultShouldDehydrateQuery,
} from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";

export const queryClient = new QueryClient();

const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
});

persistQueryClient({
  queryClient,
  persister: localStoragePersister,
  maxAge: 1000 * 60 * 60 * 24, // 24 hours
  dehydrateOptions: {
    // Opt-out for queries that must not be written to localStorage — set
    // `meta: { persist: false }` on the query. Used by anything holding
    // credentials or other data that shouldn't outlive the page.
    shouldDehydrateQuery: (query) =>
      query.meta?.persist !== false && defaultShouldDehydrateQuery(query),
  },
});
